/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { GeometryLabelDto } from './GeometryLabelDto';
import {
    GeometryLabelDtoFromJSON,
    GeometryLabelDtoFromJSONTyped,
    GeometryLabelDtoToJSON,
} from './GeometryLabelDto';
import type { DefinitionDto } from './DefinitionDto';
import {
    DefinitionDtoFromJSON,
    DefinitionDtoFromJSONTyped,
    DefinitionDtoToJSON,
} from './DefinitionDto';
import type { RtSystemQuantityScopeDto } from './RtSystemQuantityScopeDto';
import {
    RtSystemQuantityScopeDtoFromJSON,
    RtSystemQuantityScopeDtoFromJSONTyped,
    RtSystemQuantityScopeDtoToJSON,
} from './RtSystemQuantityScopeDto';

/**
 * 
 * @export
 * @interface EvaluationQuantityUsageDto
 */
export interface EvaluationQuantityUsageDto {
    /**
     * 
     * @type {boolean}
     * @memberof EvaluationQuantityUsageDto
     */
    isUsageEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EvaluationQuantityUsageDto
     */
    useEvaluationGeometry?: boolean;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof EvaluationQuantityUsageDto
     */
    medicalSystemScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof EvaluationQuantityUsageDto
     */
    qaEquipmentScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {Array<GeometryLabelDto>}
     * @memberof EvaluationQuantityUsageDto
     */
    evaluationGeometries?: Array<GeometryLabelDto> | null;
    /**
     * 
     * @type {Array<DefinitionDto>}
     * @memberof EvaluationQuantityUsageDto
     */
    definitions?: Array<DefinitionDto> | null;
    /**
     * 
     * @type {string}
     * @memberof EvaluationQuantityUsageDto
     */
    $type?: EvaluationQuantityUsageDtoTypeEnum;
}


/**
 * @export
 */
export const EvaluationQuantityUsageDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoEvaluationQuantityUsageDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.EvaluationQuantityUsageDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EvaluationQuantityUsageDtoTypeEnum = typeof EvaluationQuantityUsageDtoTypeEnum[keyof typeof EvaluationQuantityUsageDtoTypeEnum];



/**
 * Check if a given object implements the EvaluationQuantityUsageDto interface.
 */
export function instanceOfEvaluationQuantityUsageDto(value?: unknown): value is EvaluationQuantityUsageDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EvaluationQuantityUsageDtoTypeEnum)[0];
}

export function EvaluationQuantityUsageDtoFromJSON(json: any): EvaluationQuantityUsageDto {
    return EvaluationQuantityUsageDtoFromJSONTyped(json, false);
}

export function EvaluationQuantityUsageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationQuantityUsageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isUsageEnabled': json['isUsageEnabled'] == null ? undefined : json['isUsageEnabled'],
        'useEvaluationGeometry': json['useEvaluationGeometry'] == null ? undefined : json['useEvaluationGeometry'],
        'medicalSystemScope': json['medicalSystemScope'] == null ? undefined : ((json['medicalSystemScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        'qaEquipmentScope': json['qaEquipmentScope'] == null ? undefined : ((json['qaEquipmentScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        'evaluationGeometries': json['evaluationGeometries'] == null ? undefined : ((json['evaluationGeometries'] as Array<any>).map(GeometryLabelDtoFromJSON)),
        'definitions': json['definitions'] == null ? undefined : ((json['definitions'] as Array<any>).map(DefinitionDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EvaluationQuantityUsageDtoToJSON(value?: EvaluationQuantityUsageDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'isUsageEnabled': value['isUsageEnabled'],
        'useEvaluationGeometry': value['useEvaluationGeometry'],
        'medicalSystemScope': value['medicalSystemScope'] == null ? undefined : ((value['medicalSystemScope'] as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        'qaEquipmentScope': value['qaEquipmentScope'] == null ? undefined : ((value['qaEquipmentScope'] as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        'evaluationGeometries': value['evaluationGeometries'] == null ? undefined : ((value['evaluationGeometries'] as Array<any>).map(GeometryLabelDtoToJSON)),
        'definitions': value['definitions'] == null ? undefined : ((value['definitions'] as Array<any>).map(DefinitionDtoToJSON)),
        '$type': value['$type'],
    });
}

